export const Details = [
    {
      "ID": 1,
      "MuseumName": "1749 COURT HOUSE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "132 SOUTH STREET",
      "ZipCode": 2360,
      "StreetAddress(PhysicalLocation)": "2 TOWN SQUARE",
      "City(PhysicalLocation)": "PLYMOUTH",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5088304075,
      "Latitude": 41.95561,
      "Longitude": -70.66431
    },
    {
      "ID": 2,
      "MuseumName": "1794 MEETINGHOUSE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 8",
      "ZipCode": 1355,
      "StreetAddress(PhysicalLocation)": "26 S MAIN ST",
      "City(PhysicalLocation)": "NEW SALEM",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9785445200,
      "Latitude": 42.49631,
      "Longitude": -72.33096
    },
    {
      "ID": 3,
      "MuseumName": "5TH MASS BATTERY E LIGHT ARTILLERY ARMY OF POTOMAC",
      "StreetAddress(AdministrativeLocation)": "PO BOX 861",
      "ZipCode": 1867,
      "StreetAddress(PhysicalLocation)": "5TH MASSACHUSETTS BATTERY E",
      "City(PhysicalLocation)": "READING",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.52755,
      "Longitude": -71.10778
    },
    {
      "ID": 4,
      "MuseumName": "888 WOMENS HISTORY PROJECT",
      "StreetAddress(AdministrativeLocation)": "69 SPRING ST",
      "ZipCode": 2141,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6177383381,
      "Latitude": 42.36918,
      "Longitude": -71.08139
    },
    {
      "ID": 5,
      "MuseumName": "ABIGAIL ADAMS HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 147",
      "ZipCode": 2191,
      "StreetAddress(PhysicalLocation)": "180 NORTON STREET",
      "City(PhysicalLocation)": "NORTH WEYMOUTH",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 7812771271,
      "Latitude": 42.23223,
      "Longitude": -70.94574
    },
    {
      "ID": 6,
      "MuseumName": "ABRAHAM BROWNE HOUSE",
      "StreetAddress(AdministrativeLocation)": "562 MAIN ST",
      "ZipCode": 2472,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.37243,
      "Longitude": -71.20058
    },
    {
      "ID": 7,
      "MuseumName": "ACTON ARBORETUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 2607",
      "ZipCode": 1720,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9782649631,
      "Latitude": 42.4818,
      "Longitude": -71.44332
    },
    {
      "ID": 8,
      "MuseumName": "ACTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 2389",
      "ZipCode": 1720,
      "StreetAddress(PhysicalLocation)": "300 MAIN ST",
      "City(PhysicalLocation)": "ACTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9782640690,
      "Latitude": 42.47652,
      "Longitude": -71.45112
    },
    {
      "ID": 9,
      "MuseumName": "ADAMS HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "92 PARK ST",
      "ZipCode": 1220,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4137431799,
      "Latitude": 42.62335,
      "Longitude": -73.12049
    },
    {
      "ID": 10,
      "MuseumName": "ADAMS NATIONAL HISTORICAL PARK",
      "StreetAddress(AdministrativeLocation)": "135 ADAMS ST",
      "ZipCode": 2169,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6177731177,
      "Latitude": 42.25641,
      "Longitude": -71.01116
    },
    {
      "ID": 11,
      "MuseumName": "ADDISON GALLERY OF AMERICAN ART",
      "StreetAddress(AdministrativeLocation)": "PHILLIPS ACADEMY",
      "ZipCode": 1810,
      "StreetAddress(PhysicalLocation)": "PHILLIPS ACADEMY",
      "City(PhysicalLocation)": "ANDOVER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9787494015,
      "Latitude": 42.65102,
      "Longitude": -71.15755
    },
    {
      "ID": 12,
      "MuseumName": "ADOLPHUS BUSCH HALL",
      "StreetAddress(AdministrativeLocation)": "29 KIRKLAND STREET",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "29 KIRKLAND STREET",
      "City(PhysicalLocation)": "CAMBRIDGE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6174959400,
      "Latitude": 42.37682,
      "Longitude": -71.1136
    },
    {
      "ID": 13,
      "MuseumName": "AFRICAN AMERICAN HERITAGE TRAIL OF MARTHA'S VINEYARD",
      "StreetAddress(AdministrativeLocation)": "PO BOX 596",
      "ZipCode": 2575,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086934361,
      "Latitude": 41.39602,
      "Longitude": -70.6576
    },
    {
      "ID": 14,
      "MuseumName": "AFRICAN MEETING HOUSE",
      "StreetAddress(AdministrativeLocation)": "14 BEACON ST",
      "ZipCode": 2108,
      "StreetAddress(PhysicalLocation)": "46 JOY STREET",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6177250022,
      "Latitude": 42.36007,
      "Longitude": -71.06516
    },
    {
      "ID": 15,
      "MuseumName": "AGAWAM HISTORICAL ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "35 ELM ST",
      "ZipCode": 1001,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4137894631,
      "Latitude": 42.07241,
      "Longitude": -72.61811
    },
    {
      "ID": 16,
      "MuseumName": "AIR TRANSPORT MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 715",
      "ZipCode": 1845,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.70263,
      "Longitude": -71.13076
    },
    {
      "ID": 17,
      "MuseumName": "ALBERT J THOMAS LIBRARY MUSEUM",
      "StreetAddress(AdministrativeLocation)": "425 MAIN ST",
      "ZipCode": 1543,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5088866172,
      "Latitude": 42.36455,
      "Longitude": -71.98357
    },
    {
      "ID": 18,
      "MuseumName": "ALDEN HOUSE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "105 ALDEN ST",
      "ZipCode": 2331,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7819349092,
      "Latitude": 42.02599,
      "Longitude": -70.68381
    },
    {
      "ID": 19,
      "MuseumName": "ALDEN PLANETARIUM",
      "StreetAddress(AdministrativeLocation)": "222 HARRINGTON WAY",
      "ZipCode": 1604,
      "StreetAddress(PhysicalLocation)": "222 HARRINGTON WAY",
      "City(PhysicalLocation)": "WORCESTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.26176,
      "Longitude": -71.76666
    },
    {
      "ID": 20,
      "MuseumName": "ALEXANDRA BOTANIC GARDEN",
      "StreetAddress(AdministrativeLocation)": "106 CENTRAL ST",
      "ZipCode": 2481,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.29586,
      "Longitude": -71.29916
    },
    {
      "ID": 21,
      "MuseumName": "AMAZING WORLD OF DR SUESS MUSEUM",
      "StreetAddress(AdministrativeLocation)": "21 EDWARDS ST",
      "ZipCode": 1103,
      "StreetAddress(PhysicalLocation)": "21 EDWARDS ST",
      "City(PhysicalLocation)": "SPRINGFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.1043,
      "Longitude": -72.58708
    },
    {
      "ID": 22,
      "MuseumName": "AMELIA PARK CHILDREN'S MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 931",
      "ZipCode": 1086,
      "StreetAddress(PhysicalLocation)": "29 S BROAD ST",
      "City(PhysicalLocation)": "WESTFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135724014,
      "Latitude": 42.11175,
      "Longitude": -72.74782
    },
    {
      "ID": 23,
      "MuseumName": "AMERICAN ANTIQUARIAN SOCIETY",
      "StreetAddress(AdministrativeLocation)": "185 SALISBURY ST",
      "ZipCode": 1609,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5087555221,
      "Latitude": 42.27727,
      "Longitude": -71.81028
    },
    {
      "ID": 24,
      "MuseumName": "AMERICAN HAND FIRE ENGINE SOCIETY",
      "StreetAddress(AdministrativeLocation)": "0 MORGAN AVE",
      "ZipCode": 1951,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5084653948,
      "Latitude": 42.79745,
      "Longitude": -70.86115
    },
    {
      "ID": 25,
      "MuseumName": "AMERICAN JEWISH HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "99-101 NEWBURY STREET",
      "ZipCode": 2116,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6172261245,
      "Latitude": 43.85601,
      "Longitude": -70.02955
    },
    {
      "ID": 26,
      "MuseumName": "AMERICAN SOCIETY FOR LEGAL HISTORY",
      "StreetAddress(AdministrativeLocation)": "1545 MASSACHUSETTS AVENUE NO 335",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.37889,
      "Longitude": -71.12002
    },
    {
      "ID": 27,
      "MuseumName": "AMERICAN TEXTILE HISTORY MUSEUM",
      "StreetAddress(AdministrativeLocation)": "491 DUTTON ST",
      "ZipCode": 1854,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9784410400,
      "Latitude": 42.64161,
      "Longitude": -71.31667
    },
    {
      "ID": 28,
      "MuseumName": "AMESBURY CARRIAGE MUSUEM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 252",
      "ZipCode": 1913,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.85085,
      "Longitude": -70.93146
    },
    {
      "ID": 29,
      "MuseumName": "AMESBURY HAT MUSEUM",
      "StreetAddress(AdministrativeLocation)": "1 CARPENTER ST",
      "ZipCode": 1913,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9783385359,
      "Latitude": 42.85041,
      "Longitude": -70.93283
    },
    {
      "ID": 30,
      "MuseumName": "AMHERST CENTER FOR RUSSIAN CULTURE",
      "StreetAddress(AdministrativeLocation)": "11 BARRETT HILL ROAD",
      "ZipCode": 1002,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4135422350,
      "Latitude": 42.34683,
      "Longitude": -72.52669
    },
    {
      "ID": 31,
      "MuseumName": "AMHERST HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "67 AMITY ST",
      "ZipCode": 1002,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4132560678,
      "Latitude": 42.37631,
      "Longitude": -72.52083
    },
    {
      "ID": 32,
      "MuseumName": "AMHERST HISTORY MUSEUM AT THE STRONG HOUSE",
      "StreetAddress(AdministrativeLocation)": "67 AMITY STREET",
      "ZipCode": 1002,
      "StreetAddress(PhysicalLocation)": "67 AMITY STREET",
      "City(PhysicalLocation)": "AMHERST",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4132560678,
      "Latitude": 42.37631,
      "Longitude": -72.52083
    },
    {
      "ID": 33,
      "MuseumName": "AMHERST RAILWAY SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 247",
      "ZipCode": 1057,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4132674555,
      "Latitude": 42.11673,
      "Longitude": -72.30369
    },
    {
      "ID": 34,
      "MuseumName": "AMY H. CARBERRY FINE ARTS GALLERY",
      "StreetAddress(AdministrativeLocation)": "ONE ARMORY SQUARE SUITE 1",
      "ZipCode": 1102,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.11077,
      "Longitude": -72.57874
    },
    {
      "ID": 35,
      "MuseumName": "ANCIENT AND HONORABLE ARTILLERY",
      "StreetAddress(AdministrativeLocation)": "CONGRESS ST",
      "ZipCode": 20108,
      "StreetAddress(PhysicalLocation)": "1 FANEUIL HALL SQUARE",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6172271638,
      "Latitude": 42.36003,
      "Longitude": -71.05623
    },
    {
      "ID": 36,
      "MuseumName": "ANDOVER HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "97 MAIN ST",
      "ZipCode": 1810,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9784752236,
      "Latitude": 42.65337,
      "Longitude": -71.1392
    },
    {
      "ID": 37,
      "MuseumName": "ANIMAGIC MUSEUM OF ANIMATION",
      "StreetAddress(AdministrativeLocation)": "77 MAIN ST",
      "ZipCode": 1238,
      "StreetAddress(PhysicalLocation)": "135 MAIN ST",
      "City(PhysicalLocation)": "LEE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4138416679,
      "Latitude": 42.23662,
      "Longitude": -73.19389
    },
    {
      "ID": 38,
      "MuseumName": "APTUCXET TRADING POST MUSEUM",
      "StreetAddress(AdministrativeLocation)": "24 APTUCXET RD",
      "ZipCode": 2532,
      "StreetAddress(PhysicalLocation)": "24 APTUCXET RD",
      "City(PhysicalLocation)": "BOURNE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5087599487,
      "Latitude": 41.74244,
      "Longitude": -70.60328
    },
    {
      "ID": 39,
      "MuseumName": "AQUINNAH CULTURAL CENTER",
      "StreetAddress(AdministrativeLocation)": "35 AQUINNAH CIR",
      "ZipCode": 2535,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086457900,
      "Latitude": 41.33571,
      "Longitude": -70.79545
    },
    {
      "ID": 40,
      "MuseumName": "ARBORETUM PARK CONSERVANCY",
      "StreetAddress(AdministrativeLocation)": "3 POST OFFICE SQUARE 3RD FLOOR",
      "ZipCode": 2109,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6175564110,
      "Latitude": 42.3575,
      "Longitude": -71.0564
    },
    {
      "ID": 41,
      "MuseumName": "ARLINGTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "7 JASON ST",
      "ZipCode": 2476,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7816484300,
      "Latitude": 42.41581,
      "Longitude": -71.1584
    },
    {
      "ID": 42,
      "MuseumName": "ARLINGTON NATURAL RESOURCES",
      "StreetAddress(AdministrativeLocation)": "730 MASSACHUSETTS AVE",
      "ZipCode": 2476,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7816461000,
      "Latitude": 42.41616,
      "Longitude": -71.15663
    },
    {
      "ID": 43,
      "MuseumName": "ARMENIAN LIBRARY AND MUSEUM OF AMERICA",
      "StreetAddress(AdministrativeLocation)": "65 MAIN STREET",
      "ZipCode": 2472,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6179262562,
      "Latitude": 42.36609,
      "Longitude": -71.18561
    },
    {
      "ID": 44,
      "MuseumName": "ARNHEIM GALLERY",
      "StreetAddress(AdministrativeLocation)": "621 HUNTINGTON AVE",
      "ZipCode": 2115,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.33597,
      "Longitude": -71.10044
    },
    {
      "ID": 45,
      "MuseumName": "ARNO MARIS GALLERY",
      "StreetAddress(AdministrativeLocation)": "577 WESTERN AVE",
      "ZipCode": 1086,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4135724400,
      "Latitude": 42.12913,
      "Longitude": -72.79351
    },
    {
      "ID": 46,
      "MuseumName": "ARNOLD ARBORETUM",
      "StreetAddress(AdministrativeLocation)": "6 HOPKINS ROAD",
      "ZipCode": 2130,
      "StreetAddress(PhysicalLocation)": "6 HOPKINS ROAD",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6175241718,
      "Latitude": 42.30836,
      "Longitude": -71.13356
    },
    {
      "ID": 47,
      "MuseumName": "ARNOLD ARBORETUM OF HARVARD UNIVERSITY JAMAICA PLAIN",
      "StreetAddress(AdministrativeLocation)": "125 ARBORWAY",
      "ZipCode": 2130,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6175241718,
      "Latitude": 42.36977,
      "Longitude": -71.11216
    },
    {
      "ID": 48,
      "MuseumName": "ARNOLD B. TOFIAS INDUSTRIAL ARCHIVES",
      "StreetAddress(AdministrativeLocation)": "320 WASHINGTON STREET",
      "ZipCode": 2357,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5085651403,
      "Latitude": 42.05943,
      "Longitude": -71.08086
    },
    {
      "ID": 49,
      "MuseumName": "ARROWHEAD MUSEUM",
      "StreetAddress(AdministrativeLocation)": "780 HOLMES RD",
      "ZipCode": 1201,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4134421793,
      "Latitude": 42.42002,
      "Longitude": -73.24628
    },
    {
      "ID": 50,
      "MuseumName": "ART CENTER GALLERY",
      "StreetAddress(AdministrativeLocation)": "50 SUNSET LANE",
      "ZipCode": 1612,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5088493330,
      "Latitude": 42.32699,
      "Longitude": -71.91731
    },
    {
      "ID": 51,
      "MuseumName": "ART COMPLEX AT DUXBURY",
      "StreetAddress(AdministrativeLocation)": "189 ALDEN ST",
      "ZipCode": 2332,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7819346634,
      "Latitude": 42.04329,
      "Longitude": -70.68901
    },
    {
      "ID": 52,
      "MuseumName": "ART GALLERY",
      "StreetAddress(AdministrativeLocation)": "1215 WILBRAHAM RD",
      "ZipCode": 1119,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.11622,
      "Longitude": -72.5226
    },
    {
      "ID": 53,
      "MuseumName": "ARTISTS ASSOCIATION OF NANTUCKET",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1104",
      "ZipCode": 2554,
      "StreetAddress(PhysicalLocation)": "1 GARDNER PERRY LANE",
      "City(PhysicalLocation)": "NANTUCKET",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5082280722,
      "Latitude": 41.2756,
      "Longitude": -70.09785
    },
    {
      "ID": 54,
      "MuseumName": "ARTS INSTITUTE GROUP OF THE MERRIMACK VALLEY",
      "StreetAddress(AdministrativeLocation)": "39 COUNTY ROAD",
      "ZipCode": 1810,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.72877,
      "Longitude": -71.17767
    },
    {
      "ID": 55,
      "MuseumName": "ARUNAH HILL NATURAL SCIENCE CENTER",
      "StreetAddress(AdministrativeLocation)": "218 TROUBLE STREET",
      "ZipCode": 1026,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4136340180,
      "Latitude": 42.44705,
      "Longitude": -72.97653
    },
    {
      "ID": 56,
      "MuseumName": "ARUNAH HILL PLANETARIUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 16",
      "ZipCode": 1373,
      "StreetAddress(PhysicalLocation)": "218 TROUBLE STREET",
      "City(PhysicalLocation)": "CUMMINGTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.44705,
      "Longitude": -72.97653
    },
    {
      "ID": 57,
      "MuseumName": "ASHBURNHAM HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 692",
      "ZipCode": 1430,
      "StreetAddress(PhysicalLocation)": "79 MAIN STREET",
      "City(PhysicalLocation)": "ASHBURNHAM",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9788276639,
      "Latitude": 42.63599,
      "Longitude": -71.91304
    },
    {
      "ID": 58,
      "MuseumName": "ASHFIELD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 277",
      "ZipCode": 1330,
      "StreetAddress(PhysicalLocation)": "457 MAIN STREET",
      "City(PhysicalLocation)": "ASHFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4136280001,
      "Latitude": 42.51294,
      "Longitude": -72.85977
    },
    {
      "ID": 59,
      "MuseumName": "ASHLAND HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 145",
      "ZipCode": 1721,
      "StreetAddress(PhysicalLocation)": "2 MYRTLE STREET P O BOX 145",
      "City(PhysicalLocation)": "ASHLAND",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5088818183,
      "Latitude": 42.25589,
      "Longitude": -71.45959
    },
    {
      "ID": 60,
      "MuseumName": "ATHENEUM SOCIETY OF WILBRAHAM",
      "StreetAddress(AdministrativeLocation)": "450 MAIN ST",
      "ZipCode": 1095,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4135964097,
      "Latitude": 42.12278,
      "Longitude": -72.43112
    },
    {
      "ID": 61,
      "MuseumName": "ATHOL HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 21",
      "ZipCode": 1331,
      "StreetAddress(PhysicalLocation)": "1307 MAIN STREET",
      "City(PhysicalLocation)": "ATHOL",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9782495835,
      "Latitude": 42.5936,
      "Longitude": -72.21805
    },
    {
      "ID": 62,
      "MuseumName": "ATTLEBORO AREA INDUSTRIAL MUSEUM",
      "StreetAddress(AdministrativeLocation)": "42 UNION STREET",
      "ZipCode": 2703,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082223918,
      "Latitude": 41.943,
      "Longitude": -71.282
    },
    {
      "ID": 63,
      "MuseumName": "ATTLEBORO HISTORIC PRESERVATION SOCIETY",
      "StreetAddress(AdministrativeLocation)": "28 SANFORD ST",
      "ZipCode": 2703,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082232222,
      "Latitude": 41.94558,
      "Longitude": -71.28561
    },
    {
      "ID": 64,
      "MuseumName": "ATTLEBORO MUSEUM",
      "StreetAddress(AdministrativeLocation)": "86 PARK ST",
      "ZipCode": 2703,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082222644,
      "Latitude": 41.94439,
      "Longitude": -71.28161
    },
    {
      "ID": 65,
      "MuseumName": "AUBURN HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "41 SOUTH STREET",
      "ZipCode": 1501,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5088326856,
      "Latitude": 42.19006,
      "Longitude": -71.83462
    },
    {
      "ID": 66,
      "MuseumName": "AUDIO RECRODING MUSEUM OF SCIENCE",
      "StreetAddress(AdministrativeLocation)": "248A OLD LYMAN RD",
      "ZipCode": 1075,
      "StreetAddress(PhysicalLocation)": "248A OLD LYMAN RD",
      "City(PhysicalLocation)": "SOUTH HADLEY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135330900,
      "Latitude": 42.22033,
      "Longitude": -72.56532
    },
    {
      "ID": 67,
      "MuseumName": "AUTHUR M. SACKLER MUSEUM",
      "StreetAddress(AdministrativeLocation)": "32 QUINCY STREET",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6174959400,
      "Latitude": 42.36977,
      "Longitude": -71.11216
    },
    {
      "ID": 68,
      "MuseumName": "BABSON MAP AND GLOBE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "MAP HILL DRIVE",
      "ZipCode": 2157,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7812351200,
      "Latitude": null,
      "Longitude": null
    },
    {
      "ID": 69,
      "MuseumName": "BACK BAY HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "160 COMMONWEALTH AVE",
      "ZipCode": 2116,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.35152,
      "Longitude": -71.07825
    },
    {
      "ID": 70,
      "MuseumName": "BAKALAR & PAINE GALLERIES",
      "StreetAddress(AdministrativeLocation)": "621 HUNTINGTON AVE",
      "ZipCode": 2115,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6178797337,
      "Latitude": 42.33597,
      "Longitude": -71.10044
    },
    {
      "ID": 71,
      "MuseumName": "BARE COVE FIRE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "45 BARE COVE PARK DRIVE",
      "ZipCode": 2043,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7817490028,
      "Latitude": 42.23291,
      "Longitude": -70.90911
    },
    {
      "ID": 72,
      "MuseumName": "BARNSTABLE",
      "StreetAddress(AdministrativeLocation)": "367 MAIN ST",
      "ZipCode": 2601,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5083628448,
      "Latitude": 41.65434,
      "Longitude": -70.29606
    },
    {
      "ID": 73,
      "MuseumName": "BARNSTABLE COUNTY CATALDO ARCHIVES",
      "StreetAddress(AdministrativeLocation)": "3195 MAIN STREET",
      "ZipCode": 2630,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 41.69998,
      "Longitude": -70.30035
    },
    {
      "ID": 74,
      "MuseumName": "BARNSTABLE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 829",
      "ZipCode": 2630,
      "StreetAddress(PhysicalLocation)": "3087 MAIN STREET",
      "City(PhysicalLocation)": "BARNSTABLE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5083622982,
      "Latitude": 41.70393,
      "Longitude": -70.3108
    },
    {
      "ID": 75,
      "MuseumName": "BARRE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 755",
      "ZipCode": 1005,
      "StreetAddress(PhysicalLocation)": "18 COMMON ST",
      "City(PhysicalLocation)": "BARRE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9783554978,
      "Latitude": 42.42207,
      "Longitude": -72.10603
    },
    {
      "ID": 76,
      "MuseumName": "BARTLETT MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 692",
      "ZipCode": 1913,
      "StreetAddress(PhysicalLocation)": "270 MAIN STREET",
      "City(PhysicalLocation)": "AMESBURY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9783884528,
      "Latitude": 42.84504,
      "Longitude": -70.92755
    },
    {
      "ID": 77,
      "MuseumName": "BASSETT PLANETARIUM",
      "StreetAddress(AdministrativeLocation)": "BOLTWOOD AVENUE",
      "ZipCode": 1002,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.34683,
      "Longitude": -72.52669
    },
    {
      "ID": 78,
      "MuseumName": "BATTLESHIP COVE",
      "StreetAddress(AdministrativeLocation)": "5 WATER STREET BATTLESHIP COVE",
      "ZipCode": 2721,
      "StreetAddress(PhysicalLocation)": "5 WATER ST",
      "City(PhysicalLocation)": "FALL RIVER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5086781905,
      "Latitude": 41.70313,
      "Longitude": -71.16398
    },
    {
      "ID": 79,
      "MuseumName": "BAY STATE MODEL RAILROAD MUSEUM",
      "StreetAddress(AdministrativeLocation)": "760 SOUTH ST",
      "ZipCode": 2131,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6173274341,
      "Latitude": 42.28698,
      "Longitude": -71.12927
    },
    {
      "ID": 80,
      "MuseumName": "BEARD AND WEIL GALLERIES",
      "StreetAddress(AdministrativeLocation)": "501 COLLEGE AVE",
      "ZipCode": 60187,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 41.8674,
      "Longitude": -88.09879
    },
    {
      "ID": 81,
      "MuseumName": "BECKETT LAND TRUST AND HISTORIC",
      "StreetAddress(AdministrativeLocation)": "12 BROOKER HILL RD",
      "ZipCode": 1223,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4136232100,
      "Latitude": 42.33047,
      "Longitude": -73.09124
    },
    {
      "ID": 82,
      "MuseumName": "BEDFORD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "2 MUDGE WAY",
      "ZipCode": 1730,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7812757276,
      "Latitude": 42.49249,
      "Longitude": -71.28317
    },
    {
      "ID": 83,
      "MuseumName": "BELCHERTOWN HISTORICAL ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1211",
      "ZipCode": 1007,
      "StreetAddress(PhysicalLocation)": "20 MAPLE ST",
      "City(PhysicalLocation)": "BELCHERTOWN",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4133237052,
      "Latitude": 42.27607,
      "Longitude": -72.40328
    },
    {
      "ID": 84,
      "MuseumName": "BELMONT HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 125",
      "ZipCode": 2478,
      "StreetAddress(PhysicalLocation)": "BELMONT",
      "City(PhysicalLocation)": "BALMONT",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6179932878,
      "Latitude": 42.39122,
      "Longitude": -71.17445
    },
    {
      "ID": 85,
      "MuseumName": "BELMONT LAND TRUST",
      "StreetAddress(AdministrativeLocation)": "PO BOX 79158",
      "ZipCode": 2479,
      "StreetAddress(PhysicalLocation)": "53 STULTS RD",
      "City(PhysicalLocation)": "BELMONT",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6172275585,
      "Latitude": 42.37836,
      "Longitude": -71.16502
    },
    {
      "ID": 86,
      "MuseumName": "BENTLEY LIBRARY ARTSPACE",
      "StreetAddress(AdministrativeLocation)": "100 ELLIOTT STREET",
      "ZipCode": 1830,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.79765,
      "Longitude": -71.0512
    },
    {
      "ID": 87,
      "MuseumName": "BERKLEY HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "1 N MAIN ST",
      "ZipCode": 2779,
      "StreetAddress(PhysicalLocation)": "1931 CENTER STREET",
      "City(PhysicalLocation)": "BERKELEY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5108480181,
      "Latitude": 41.83372,
      "Longitude": -71.07925
    },
    {
      "ID": 88,
      "MuseumName": "BERKSHIRE ART ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "PO BOX 385",
      "ZipCode": 1202,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.45044,
      "Longitude": -73.25214
    },
    {
      "ID": 89,
      "MuseumName": "BERKSHIRE BOTANICAL GARDEN",
      "StreetAddress(AdministrativeLocation)": "PO BOX 826",
      "ZipCode": 1262,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4132983926,
      "Latitude": 42.30069,
      "Longitude": -73.31328
    },
    {
      "ID": 90,
      "MuseumName": "BERKSHIRE CAROUSEL",
      "StreetAddress(AdministrativeLocation)": "PO BOX 23",
      "ZipCode": 1227,
      "StreetAddress(PhysicalLocation)": "8 OLD STATE RD",
      "City(PhysicalLocation)": "DALTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4134990342,
      "Latitude": 42.47297,
      "Longitude": -73.16392
    },
    {
      "ID": 91,
      "MuseumName": "BERKSHIRE COUNTY HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "780 HOLMES RD",
      "ZipCode": 1201,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4134421793,
      "Latitude": 42.42002,
      "Longitude": -73.24628
    },
    {
      "ID": 92,
      "MuseumName": "BERKSHIRE COUNTY MUSEUM OF FIREFIGHTING",
      "StreetAddress(AdministrativeLocation)": "BARKER RD",
      "ZipCode": 1201,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.45328,
      "Longitude": -73.24936
    },
    {
      "ID": 93,
      "MuseumName": "BERKSHIRE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "39 SOUTH ST",
      "ZipCode": 1201,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4134437171,
      "Latitude": 42.44693,
      "Longitude": -73.25357
    },
    {
      "ID": 94,
      "MuseumName": "BERKSHIRE SCENIC RAILWAY MUSEUM",
      "StreetAddress(AdministrativeLocation)": "10 WILLOW CREEK RD",
      "ZipCode": 1240,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4136372210,
      "Latitude": 42.33485,
      "Longitude": -73.26668
    },
    {
      "ID": 95,
      "MuseumName": "BERLIN ART AND HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "POB 35",
      "ZipCode": 1503,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9788382307,
      "Latitude": 42.3816,
      "Longitude": -71.63474
    },
    {
      "ID": 96,
      "MuseumName": "BERNARDSTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 44",
      "ZipCode": 1337,
      "StreetAddress(PhysicalLocation)": "38 CHURCH ST",
      "City(PhysicalLocation)": "BERNARDSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4136485407,
      "Latitude": 42.67077,
      "Longitude": -72.54819
    },
    {
      "ID": 97,
      "MuseumName": "BEVERLY HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "117 CABOT ST",
      "ZipCode": 1915,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9789221186,
      "Latitude": 42.54571,
      "Longitude": -70.87963
    },
    {
      "ID": 98,
      "MuseumName": "BIDWELL HOUSE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 537",
      "ZipCode": 1245,
      "StreetAddress(PhysicalLocation)": "100 ART SCHOOL ROAD",
      "City(PhysicalLocation)": "MONTEREY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135286888,
      "Latitude": 42.18071,
      "Longitude": -73.19597
    },
    {
      "ID": 99,
      "MuseumName": "BILLERICA HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 381",
      "ZipCode": 1821,
      "StreetAddress(PhysicalLocation)": "36 CONCORD ROAD",
      "City(PhysicalLocation)": "BILLERICA",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9786677020,
      "Latitude": 42.55581,
      "Longitude": -71.26959
    },
    {
      "ID": 100,
      "MuseumName": "BISBEE MILL",
      "StreetAddress(AdministrativeLocation)": "66 EAST ST",
      "ZipCode": 1012,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4132964465,
      "Latitude": 42.37424,
      "Longitude": -72.82383
    },
    {
      "ID": 101,
      "MuseumName": "BLACK TAVERN HISTORICAL SOCIETY OF DUDLEY MA",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1804 DUDLEY HILL",
      "ZipCode": 1571,
      "StreetAddress(PhysicalLocation)": "36 TANYARD ROAD",
      "City(PhysicalLocation)": "DUDLEY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089438782,
      "Latitude": 42.04571,
      "Longitude": -71.92982
    },
    {
      "ID": 102,
      "MuseumName": "BLACKBURN TAVERN",
      "StreetAddress(AdministrativeLocation)": "2 MAIN ST",
      "ZipCode": 1930,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9782821919,
      "Latitude": 42.61184,
      "Longitude": -70.66566
    },
    {
      "ID": 103,
      "MuseumName": "BLACKSTONE CANAL CONSERVANCY",
      "StreetAddress(AdministrativeLocation)": "16 BALLOU ROAD",
      "ZipCode": 1747,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.12495,
      "Longitude": -71.54945
    },
    {
      "ID": 104,
      "MuseumName": "BLACKSTONE VALLEY ANGEL OF HOPE",
      "StreetAddress(AdministrativeLocation)": "58 SARATOGA DRIVE",
      "ZipCode": 1569,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.04381,
      "Longitude": -71.59457
    },
    {
      "ID": 105,
      "MuseumName": "BLANDFORD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "9 HAIGHT RD",
      "ZipCode": 1008,
      "StreetAddress(PhysicalLocation)": "1 NORTH STREET",
      "City(PhysicalLocation)": "BLANDFORD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4138480108,
      "Latitude": 42.18971,
      "Longitude": -72.93269
    },
    {
      "ID": 106,
      "MuseumName": "BLUE HILL ADVENTURES & QUARRY MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO 843",
      "ZipCode": 2090,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.21756,
      "Longitude": -71.20854
    },
    {
      "ID": 107,
      "MuseumName": "BLUE HILL OBSERVATORY SCIENCE CENTER",
      "StreetAddress(AdministrativeLocation)": "PO BOX 500",
      "ZipCode": 2186,
      "StreetAddress(PhysicalLocation)": "1904 CANTON AVE",
      "City(PhysicalLocation)": "MILTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6176960562,
      "Latitude": 42.21799,
      "Longitude": -71.11943
    },
    {
      "ID": 108,
      "MuseumName": "BOARDMAN HOUSE",
      "StreetAddress(AdministrativeLocation)": "17 HOWARD ST",
      "ZipCode": 1906,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7812334967,
      "Latitude": 42.47226,
      "Longitude": -71.03773
    },
    {
      "ID": 109,
      "MuseumName": "BOLTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "BOX 211",
      "ZipCode": 1740,
      "StreetAddress(PhysicalLocation)": "676 MAIN ST",
      "City(PhysicalLocation)": "BOLTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9787796392,
      "Latitude": 42.43295,
      "Longitude": -71.60565
    },
    {
      "ID": 110,
      "MuseumName": "BOOTT COTTON MILLS MUSEUM",
      "StreetAddress(AdministrativeLocation)": "115 JOHN ST",
      "ZipCode": 1852,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9789705000,
      "Latitude": 42.64748,
      "Longitude": -71.30758
    },
    {
      "ID": 111,
      "MuseumName": "BORGIA GALLERY",
      "StreetAddress(AdministrativeLocation)": "291 SPRINGFIELD STREET",
      "ZipCode": 1013,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.14271,
      "Longitude": -72.60276
    },
    {
      "ID": 112,
      "MuseumName": "BOSTON & MAINE RAILROAD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "9 CENTRAL ST",
      "ZipCode": 1852,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9784543600,
      "Latitude": 42.6454,
      "Longitude": -71.30844
    },
    {
      "ID": 113,
      "MuseumName": "BOSTON ATHENAEUM",
      "StreetAddress(AdministrativeLocation)": "10 1/2 BEACON ST",
      "ZipCode": 2108,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6172270270,
      "Latitude": 42.35815,
      "Longitude": -71.06208
    },
    {
      "ID": 114,
      "MuseumName": "BOSTON BRAVES HISTORICAL ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "PO BOX 67195",
      "ZipCode": 2467,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.31978,
      "Longitude": -71.16827
    },
    {
      "ID": 115,
      "MuseumName": "BOSTON CHILDREN'S MUSEUM",
      "StreetAddress(AdministrativeLocation)": "308 CONGRESS STREET",
      "ZipCode": 2210,
      "StreetAddress(PhysicalLocation)": "308 CONGRESS STREET",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6174268855,
      "Latitude": 42.35195,
      "Longitude": -71.04978
    },
    {
      "ID": 116,
      "MuseumName": "BOSTON FIRE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 347",
      "ZipCode": 2137,
      "StreetAddress(PhysicalLocation)": "PO BOX 347",
      "City(PhysicalLocation)": "READVILLE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.23507,
      "Longitude": -71.13446
    },
    {
      "ID": 117,
      "MuseumName": "BOSTON HISTORIC THEATRE DISTRICT",
      "StreetAddress(AdministrativeLocation)": "60 WOODBINE ST",
      "ZipCode": 2466,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.3463,
      "Longitude": -71.25265
    },
    {
      "ID": 118,
      "MuseumName": "BOSTON HISTORY CENTER AND MUSEUM",
      "StreetAddress(AdministrativeLocation)": "75 FEDERAL ST",
      "ZipCode": 2110,
      "StreetAddress(PhysicalLocation)": "55 COURT ST BASEMENT",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.35928,
      "Longitude": -71.05917
    },
    {
      "ID": 119,
      "MuseumName": "BOSTON HISTORY COLLABORATIVE",
      "StreetAddress(AdministrativeLocation)": "650 BEACON ST SUITE 403",
      "ZipCode": 2115,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6173500358,
      "Latitude": 42.34942,
      "Longitude": -71.09578
    },
    {
      "ID": 120,
      "MuseumName": "BOSTON IRISH FAMINE MEMORIAL",
      "StreetAddress(AdministrativeLocation)": "35 BRAINTREE HILL OFFICE PARK 105",
      "ZipCode": 2184,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7188482000,
      "Latitude": 42.2266,
      "Longitude": -71.0256
    },
    {
      "ID": 121,
      "MuseumName": "BOSTON LANDMARKS ORCHESTRA",
      "StreetAddress(AdministrativeLocation)": "10 GUEST ST #280",
      "ZipCode": 2135,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6179872000,
      "Latitude": 42.35749,
      "Longitude": -71.14824
    },
    {
      "ID": 122,
      "MuseumName": "BOSTON MAP SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 382438",
      "ZipCode": 2238,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.37346,
      "Longitude": -71.12299
    },
    {
      "ID": 123,
      "MuseumName": "BOSTON MINUTEMEN DIVISION",
      "StreetAddress(AdministrativeLocation)": "162 CLEAR POND DRIVE",
      "ZipCode": 2081,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.14151,
      "Longitude": -71.26459
    },
    {
      "ID": 124,
      "MuseumName": "BOSTON MUSEUM",
      "StreetAddress(AdministrativeLocation)": "55 COURT ST",
      "ZipCode": 2108,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6177232500,
      "Latitude": 42.35928,
      "Longitude": -71.05917
    },
    {
      "ID": 125,
      "MuseumName": "BOSTON NATIONAL HISTORICAL PARK FACILITY",
      "StreetAddress(AdministrativeLocation)": "CHARLESTOWN NAVY YARD",
      "ZipCode": 2129,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6172425603,
      "Latitude": 42.37794,
      "Longitude": -71.06291
    },
    {
      "ID": 126,
      "MuseumName": "BOSTON PRESERVATION ALLIANCE",
      "StreetAddress(AdministrativeLocation)": "45 SCHOOL ST",
      "ZipCode": 2108,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6173672458,
      "Latitude": 42.35802,
      "Longitude": -71.05942
    },
    {
      "ID": 127,
      "MuseumName": "BOSTON TEA PARTY SHIP AND MUSEUM",
      "StreetAddress(AdministrativeLocation)": "CONGRESS STREET BRG",
      "ZipCode": 2210,
      "StreetAddress(PhysicalLocation)": "306 CONGRESS ST",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6173381773,
      "Latitude": 42.35141,
      "Longitude": -71.04994
    },
    {
      "ID": 128,
      "MuseumName": "BOSTON UNIVERSITY ART GALLERY",
      "StreetAddress(AdministrativeLocation)": "855 COMMONWEALTH AVENUE",
      "ZipCode": 2215,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6173533329,
      "Latitude": 42.35198,
      "Longitude": -71.11512
    },
    {
      "ID": 129,
      "MuseumName": "BOSTONIAN SOCIETY",
      "StreetAddress(AdministrativeLocation)": "206 WASHINGTON STREET",
      "ZipCode": 2109,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6177201713,
      "Latitude": 42.35787,
      "Longitude": -71.05782
    },
    {
      "ID": 130,
      "MuseumName": "BOTANIC GARDEN OF SMITH COLLEGE",
      "StreetAddress(AdministrativeLocation)": "ELM ST",
      "ZipCode": 1063,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.30139,
      "Longitude": -72.5737
    },
    {
      "ID": 131,
      "MuseumName": "BOURNE HISTORICAL CENTER AND ARCHIVES",
      "StreetAddress(AdministrativeLocation)": "30 KEENE ST",
      "ZipCode": 2532,
      "StreetAddress(PhysicalLocation)": "PO BOX 3095",
      "City(PhysicalLocation)": "BOURNE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5087598167,
      "Latitude": 41.74742,
      "Longitude": -70.60874
    },
    {
      "ID": 132,
      "MuseumName": "BOURNE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 3095",
      "ZipCode": 2532,
      "StreetAddress(PhysicalLocation)": "30 KEENE STREET",
      "City(PhysicalLocation)": "BOURNE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5087598167,
      "Latitude": 41.74375,
      "Longitude": -70.59599
    },
    {
      "ID": 133,
      "MuseumName": "BOURNE SOCIETY FOR HISTORIC PRESERVATION",
      "StreetAddress(AdministrativeLocation)": "PO BOX 125",
      "ZipCode": 2559,
      "StreetAddress(PhysicalLocation)": "22 SANDWICH RD",
      "City(PhysicalLocation)": "BUZZARDS BAY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5087596120,
      "Latitude": 41.74253,
      "Longitude": -70.59574
    },
    {
      "ID": 134,
      "MuseumName": "BOURNE SOCIETY HISTORIC HOUSE",
      "StreetAddress(AdministrativeLocation)": "22 SANDWICH RD",
      "ZipCode": 2532,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5087596120,
      "Latitude": 41.74253,
      "Longitude": -70.59574
    },
    {
      "ID": 135,
      "MuseumName": "BOXBOROUGH HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "29 MIDDLE ROAD",
      "ZipCode": 1719,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9788441311,
      "Latitude": 42.4828,
      "Longitude": -71.51407
    },
    {
      "ID": 136,
      "MuseumName": "BOXFORD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 78",
      "ZipCode": 1921,
      "StreetAddress(PhysicalLocation)": "ELM ST",
      "City(PhysicalLocation)": "BOXFORD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9788875078,
      "Latitude": 42.67638,
      "Longitude": -71.00866
    },
    {
      "ID": 137,
      "MuseumName": "BOYLSTON HISTORICAL SOCIETY AND MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 459",
      "ZipCode": 1505,
      "StreetAddress(PhysicalLocation)": "7 CENTRAL ST",
      "City(PhysicalLocation)": "BOYLSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5088692720,
      "Latitude": 42.35445,
      "Longitude": -71.72912
    },
    {
      "ID": 138,
      "MuseumName": "BRAINTREE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "31 TENNEY RD",
      "ZipCode": 2184,
      "StreetAddress(PhysicalLocation)": "786 WASHINGTON STREET",
      "City(PhysicalLocation)": "BRAINTREE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 7818481640,
      "Latitude": 42.20648,
      "Longitude": -71.00404
    },
    {
      "ID": 139,
      "MuseumName": "BRANT GALLERY",
      "StreetAddress(AdministrativeLocation)": "621 HUNTINGTON AVE",
      "ZipCode": 2115,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.33597,
      "Longitude": -71.10044
    },
    {
      "ID": 140,
      "MuseumName": "BRAZIALIAN CULTURAL CENTER OF NEW ENGLAND",
      "StreetAddress(AdministrativeLocation)": "127 AMORY ST",
      "ZipCode": 2139,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6175475343,
      "Latitude": 42.372,
      "Longitude": -71.10045
    },
    {
      "ID": 141,
      "MuseumName": "BREWSTER HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1146",
      "ZipCode": 2631,
      "StreetAddress(PhysicalLocation)": "3171 MAIN STREET",
      "City(PhysicalLocation)": "BREWSTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5088969521,
      "Latitude": 41.77359,
      "Longitude": -70.04163
    },
    {
      "ID": 142,
      "MuseumName": "BREWSTER MEETING HOUSE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 713",
      "ZipCode": 2631,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 41.75194,
      "Longitude": -70.07338
    },
    {
      "ID": 143,
      "MuseumName": "BRICKBOTTOM ARTISTS ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "1 FITCHBURG STREET C111",
      "ZipCode": 2143,
      "StreetAddress(PhysicalLocation)": "1 FITCHBERG STREET",
      "City(PhysicalLocation)": "SOMERVILLE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6177763410,
      "Latitude": 42.37598,
      "Longitude": -71.08416
    },
    {
      "ID": 144,
      "MuseumName": "BRIGHTON-ALLSTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "20 CHESTNUT HILL AVENUE",
      "ZipCode": 2135,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.34859,
      "Longitude": -71.15336
    },
    {
      "ID": 145,
      "MuseumName": "BROCKELBANK MUSEUM",
      "StreetAddress(AdministrativeLocation)": "108 E MAIN ST",
      "ZipCode": 1833,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9783522208,
      "Latitude": 42.72732,
      "Longitude": -70.98211
    },
    {
      "ID": 146,
      "MuseumName": "BROCKTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "216 N PEARL ST",
      "ZipCode": 2301,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5085831039,
      "Latitude": 42.10087,
      "Longitude": -71.06716
    },
    {
      "ID": 147,
      "MuseumName": "BROOKLINE HISTORICAL COMMISSION",
      "StreetAddress(AdministrativeLocation)": "691 HAMMOND ST",
      "ZipCode": 2467,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.32155,
      "Longitude": -71.16314
    },
    {
      "ID": 148,
      "MuseumName": "BROOKLINE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "347 HARVARD STREET",
      "ZipCode": 2146,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6175665747,
      "Latitude": 42.3437,
      "Longitude": -71.12365
    },
    {
      "ID": 149,
      "MuseumName": "BUCKLAND HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 88",
      "ZipCode": 1338,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4136259763,
      "Latitude": 42.58124,
      "Longitude": -72.79895
    },
    {
      "ID": 150,
      "MuseumName": "BUFFALO SOLDIERS HERITAGE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 525",
      "ZipCode": 1772,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.29338,
      "Longitude": -71.52982
    },
    {
      "ID": 151,
      "MuseumName": "BULFUNCH FUND",
      "StreetAddress(AdministrativeLocation)": "131 CENTER BRIDGE RD",
      "ZipCode": 1523,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9783655570,
      "Latitude": 42.44966,
      "Longitude": -71.67136
    },
    {
      "ID": 152,
      "MuseumName": "BULLARD MEMORIAL FARM ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "275 HAVERHILL ST",
      "ZipCode": 1864,
      "StreetAddress(PhysicalLocation)": "7 BULLARD LANE",
      "City(PhysicalLocation)": "HOLLISTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5084294657,
      "Latitude": 42.19244,
      "Longitude": -71.38527
    },
    {
      "ID": 153,
      "MuseumName": "BUSCH-REISINGER MUSEUM",
      "StreetAddress(AdministrativeLocation)": "32 QUINCY STREET",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6174959400,
      "Latitude": 42.36977,
      "Longitude": -71.11216
    },
    {
      "ID": 154,
      "MuseumName": "BUTTERFLY PLACE",
      "StreetAddress(AdministrativeLocation)": "120 TYNGSBORO RD",
      "ZipCode": 1886,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9783920955,
      "Latitude": 42.64136,
      "Longitude": -71.43851
    },
    {
      "ID": 155,
      "MuseumName": "BUTTONWOOD PARK ZOO",
      "StreetAddress(AdministrativeLocation)": "425 HAWTHORN STREET",
      "ZipCode": 2740,
      "StreetAddress(PhysicalLocation)": "425 HAWTHORN STREET",
      "City(PhysicalLocation)": "NEW BEDFORD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089916178,
      "Latitude": 41.6277,
      "Longitude": -70.95179
    },
    {
      "ID": 156,
      "MuseumName": "CAHOON MUSEUM OF AMERICAN ART",
      "StreetAddress(AdministrativeLocation)": "4676 FALMOUTH RD",
      "ZipCode": 2635,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5084287581,
      "Latitude": 41.62694,
      "Longitude": -70.44024
    },
    {
      "ID": 157,
      "MuseumName": "CALVIN COOLIDGE PRESIDENTIAL LIBRARY & MUSEUM",
      "StreetAddress(AdministrativeLocation)": "20 WEST ST",
      "ZipCode": 1060,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4135871014,
      "Latitude": 42.31685,
      "Longitude": -72.63623
    },
    {
      "ID": 158,
      "MuseumName": "CAMBRIDGE CENTER FOR CHINESE CULTURE",
      "StreetAddress(AdministrativeLocation)": "411 WAVERLY OAKS ROAD",
      "ZipCode": 2452,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7817888558,
      "Latitude": 42.38667,
      "Longitude": -71.20443
    },
    {
      "ID": 159,
      "MuseumName": "CAMP KIWANEE",
      "StreetAddress(AdministrativeLocation)": "81 PERRY AVE",
      "ZipCode": 2341,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.08369,
      "Longitude": -70.90663
    },
    {
      "ID": 160,
      "MuseumName": "CAMP ST AUGUSTINE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 9139",
      "ZipCode": 2035,
      "StreetAddress(PhysicalLocation)": "109 MILL ST",
      "City(PhysicalLocation)": "FOXBORO",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5086985207,
      "Latitude": 42.04279,
      "Longitude": -71.27596
    },
    {
      "ID": 161,
      "MuseumName": "CAMPAIGN FOR THE AYER MANSION",
      "StreetAddress(AdministrativeLocation)": "395 COMM AVE",
      "ZipCode": 2215,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.34948,
      "Longitude": -71.09089
    },
    {
      "ID": 162,
      "MuseumName": "CANTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "40 ABBEY LN",
      "ZipCode": 2021,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7818280073,
      "Latitude": 42.17446,
      "Longitude": -71.13601
    },
    {
      "ID": 163,
      "MuseumName": "CAPE ANN HISTORICAL ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "27 PLEASANT STREET",
      "ZipCode": 1930,
      "StreetAddress(PhysicalLocation)": "27 PLEASANT STREET",
      "City(PhysicalLocation)": "GLOUCESTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9782830455,
      "Latitude": 42.61402,
      "Longitude": -70.66183
    },
    {
      "ID": 164,
      "MuseumName": "CAPE COD CENTER FOR THE ARTS",
      "StreetAddress(AdministrativeLocation)": "PO BOX 866",
      "ZipCode": 2638,
      "StreetAddress(PhysicalLocation)": "826 MAIN ST",
      "City(PhysicalLocation)": "DENNIS",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5083853618,
      "Latitude": 41.7398,
      "Longitude": -70.19102
    },
    {
      "ID": 165,
      "MuseumName": "CAPE COD CHILDREN'S MUSEUM",
      "StreetAddress(AdministrativeLocation)": "577 GREAT NECK RD S",
      "ZipCode": 2649,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5085398788,
      "Latitude": 41.58974,
      "Longitude": -70.47769
    },
    {
      "ID": 166,
      "MuseumName": "CAPE COD HORTICULTURAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 934",
      "ZipCode": 2655,
      "StreetAddress(PhysicalLocation)": "675 MAIN ST",
      "City(PhysicalLocation)": "BARNSTABLE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5084289936,
      "Latitude": 41.62774,
      "Longitude": -70.38138
    },
    {
      "ID": 167,
      "MuseumName": "CAPE COD MARITIME MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 443",
      "ZipCode": 2601,
      "StreetAddress(PhysicalLocation)": "135 SOUTH ST",
      "City(PhysicalLocation)": "HYANNIS PORT",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5087751723,
      "Latitude": 41.65128,
      "Longitude": -70.27989
    },
    {
      "ID": 168,
      "MuseumName": "CAPE COD MODERN HOUSE TRUST",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1191",
      "ZipCode": 2663,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5083497616,
      "Latitude": 41.74251,
      "Longitude": -70.06055
    },
    {
      "ID": 169,
      "MuseumName": "CAPE COD MUSEUM OF ART",
      "StreetAddress(AdministrativeLocation)": "60 HOPE LN",
      "ZipCode": 2638,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5083854477,
      "Latitude": 41.73359,
      "Longitude": -70.19285
    },
    {
      "ID": 170,
      "MuseumName": "CAPE COD MUSEUM OF NATURAL HISTORY",
      "StreetAddress(AdministrativeLocation)": "869 RTE 6A",
      "ZipCode": 2631,
      "StreetAddress(PhysicalLocation)": "869 MAIN ST",
      "City(PhysicalLocation)": "BREWSTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5088963867,
      "Latitude": 41.75368,
      "Longitude": -70.11693
    },
    {
      "ID": 171,
      "MuseumName": "CAPE COD NATIONAL SEASHORE",
      "StreetAddress(AdministrativeLocation)": "99 MARCONI SITE ROAD",
      "ZipCode": 2667,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082553421,
      "Latitude": 41.90387,
      "Longitude": -69.97806
    },
    {
      "ID": 172,
      "MuseumName": "CAPE COD POTTERS",
      "StreetAddress(AdministrativeLocation)": "PO BOX 76",
      "ZipCode": 2633,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5089455044,
      "Latitude": 41.68483,
      "Longitude": -69.96582
    },
    {
      "ID": 173,
      "MuseumName": "CAPEN HILL NATURE SANCTUARY",
      "StreetAddress(AdministrativeLocation)": "56 CAPEN RD",
      "ZipCode": 1507,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082485516,
      "Latitude": 42.15139,
      "Longitude": -71.9896
    },
    {
      "ID": 174,
      "MuseumName": "CAPRON PARK ZOO",
      "StreetAddress(AdministrativeLocation)": "201 COUNTY ST",
      "ZipCode": 2703,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082223047,
      "Latitude": 41.93495,
      "Longitude": -71.29889
    },
    {
      "ID": 175,
      "MuseumName": "CAPTAIN FORBES HOUSE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "215 ADAMS ST",
      "ZipCode": 2186,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 2152326778,
      "Latitude": 42.26455,
      "Longitude": -71.06497
    },
    {
      "ID": 176,
      "MuseumName": "CAPTAIN JOHN KENDRICK MARITIME",
      "StreetAddress(AdministrativeLocation)": "124 MAIN ST",
      "ZipCode": 2571,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082912274,
      "Latitude": 41.75594,
      "Longitude": -70.71334
    },
    {
      "ID": 177,
      "MuseumName": "CARDINAL SPELLMAN PHILATELIC MUSEUM",
      "StreetAddress(AdministrativeLocation)": "235 WELLESLEY ST",
      "ZipCode": 2493,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6178946735,
      "Latitude": 42.35217,
      "Longitude": -71.30508
    },
    {
      "ID": 178,
      "MuseumName": "CARLISLE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "201 GREAT ROAD",
      "ZipCode": 1720,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.51547,
      "Longitude": -71.36578
    },
    {
      "ID": 179,
      "MuseumName": "CARNEY GALLERY",
      "StreetAddress(AdministrativeLocation)": "235 WELLESLEY ST",
      "ZipCode": 2493,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7817687070,
      "Latitude": 42.35993,
      "Longitude": -71.29787
    },
    {
      "ID": 180,
      "MuseumName": "CAROLE CALO GALLERY",
      "StreetAddress(AdministrativeLocation)": "320 WASHINGTON STREET",
      "ZipCode": 2357,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": null,
      "Longitude": null
    },
    {
      "ID": 181,
      "MuseumName": "CARVER HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 581",
      "ZipCode": 2355,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5088662839,
      "Latitude": 41.92217,
      "Longitude": -70.78923
    },
    {
      "ID": 182,
      "MuseumName": "CARYL HOUSE",
      "StreetAddress(AdministrativeLocation)": "107 DEDHAM ST",
      "ZipCode": 2030,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5087853101,
      "Latitude": 42.23749,
      "Longitude": -71.28523
    },
    {
      "ID": 183,
      "MuseumName": "CASELLA GALLERY",
      "StreetAddress(AdministrativeLocation)": "ANNEX CENTRAL 1ST FLOOR",
      "ZipCode": 2115,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.33731,
      "Longitude": -71.09609
    },
    {
      "ID": 184,
      "MuseumName": "CATAUMET SCHOOL HOUSE PRESERVATION GROUP",
      "StreetAddress(AdministrativeLocation)": "649",
      "ZipCode": 2534,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5085633418,
      "Latitude": 41.66378,
      "Longitude": -70.61234
    },
    {
      "ID": 185,
      "MuseumName": "CENTER FOR CONSERVATION AND TECHNICAL STUDIES",
      "StreetAddress(AdministrativeLocation)": "32 QUINCY STREET",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6174959400,
      "Latitude": 42.36977,
      "Longitude": -71.11216
    },
    {
      "ID": 186,
      "MuseumName": "CENTER FOR HISTORIC SHIPWRECK PRESERVATION",
      "StreetAddress(AdministrativeLocation)": "16 MACMILLAN WHARF",
      "ZipCode": 2657,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.04967,
      "Longitude": -70.18258
    },
    {
      "ID": 187,
      "MuseumName": "CENTER FOR LOWELL LIBRARY",
      "StreetAddress(AdministrativeLocation)": "1 UNIVERSITY AVE",
      "ZipCode": 1854,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.65215,
      "Longitude": -71.3246
    },
    {
      "ID": 188,
      "MuseumName": "CENTER FOR VISUAL ARTS IN THE PUBLIC INTEREST",
      "StreetAddress(AdministrativeLocation)": "19 PLEASANTVIEW AVE",
      "ZipCode": 1106,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.06675,
      "Longitude": -72.58134
    },
    {
      "ID": 189,
      "MuseumName": "CENTERVILLE HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "513 MAIN ST",
      "ZipCode": 2632,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5087750331,
      "Latitude": 41.65962,
      "Longitude": -70.34777
    },
    {
      "ID": 190,
      "MuseumName": "CENTRAL MASS STEAM GAS AND MACHINERY INSTITUTE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 32",
      "ZipCode": 1364,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.59071,
      "Longitude": -72.29957
    },
    {
      "ID": 191,
      "MuseumName": "CENTRAL MASSACHUSETTS GENEALOGICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 811",
      "ZipCode": 1473,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.54899,
      "Longitude": -71.90648
    },
    {
      "ID": 192,
      "MuseumName": "CHAPIN LIBRARY OF RARE BOOKS",
      "StreetAddress(AdministrativeLocation)": "880 MAIN ST",
      "ZipCode": 1267,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.70917,
      "Longitude": -73.20466
    },
    {
      "ID": 193,
      "MuseumName": "CHARLEMONT HISTORICAL PRESERVATION SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 839",
      "ZipCode": 1339,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.62537,
      "Longitude": -72.87765
    },
    {
      "ID": 194,
      "MuseumName": "CHARLEMONT HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "25 MIDDLE ROAD",
      "ZipCode": 1339,
      "StreetAddress(PhysicalLocation)": "25 MIDDLE ROAD",
      "City(PhysicalLocation)": "CHARLEMONT",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.59838,
      "Longitude": -72.90851
    },
    {
      "ID": 195,
      "MuseumName": "CHARLES HAYDEN PLANETARIUM",
      "StreetAddress(AdministrativeLocation)": "1 SCIENCE PARK",
      "ZipCode": 2114,
      "StreetAddress(PhysicalLocation)": "1 SCIENCE PARK",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.3676,
      "Longitude": -71.07055
    },
    {
      "ID": 196,
      "MuseumName": "CHARLES RIVER MUSEUM OF INDUSTRY & INNOVATION",
      "StreetAddress(AdministrativeLocation)": "154 MOODY ST",
      "ZipCode": 2453,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.37361,
      "Longitude": -71.23649
    },
    {
      "ID": 197,
      "MuseumName": "CHARLESTOWN HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 291776",
      "ZipCode": 2129,
      "StreetAddress(PhysicalLocation)": "43 MONUMENT SQUARE",
      "City(PhysicalLocation)": "CHARLESTOWN",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6172417500,
      "Latitude": 42.37577,
      "Longitude": -71.06164
    },
    {
      "ID": 198,
      "MuseumName": "CHARLTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 252",
      "ZipCode": 1507,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082487840,
      "Latitude": 42.13921,
      "Longitude": -71.96394
    },
    {
      "ID": 199,
      "MuseumName": "CHATHAM HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 709",
      "ZipCode": 2633,
      "StreetAddress(PhysicalLocation)": "347 STAGE HARBOR RD",
      "City(PhysicalLocation)": "CHATHAM",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089452493,
      "Latitude": 41.67343,
      "Longitude": -69.96531
    },
    {
      "ID": 200,
      "MuseumName": "CHATHAM MARCONI MARITIME CENTER",
      "StreetAddress(AdministrativeLocation)": "PO BOX 421",
      "ZipCode": 2650,
      "StreetAddress(PhysicalLocation)": "847 ORLEANS RD",
      "City(PhysicalLocation)": "NORTH CHATHAM",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089458889,
      "Latitude": 41.70492,
      "Longitude": -69.98204
    },
    {
      "ID": 201,
      "MuseumName": "CHELMSFORD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "40 BYAM RD",
      "ZipCode": 1824,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7812515188,
      "Latitude": 42.58208,
      "Longitude": -71.36727
    },
    {
      "ID": 202,
      "MuseumName": "CHESTER FOUNDATION",
      "StreetAddress(AdministrativeLocation)": "10 PROSPECT ST",
      "ZipCode": 1011,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4133547878,
      "Latitude": 42.28002,
      "Longitude": -72.97787
    },
    {
      "ID": 203,
      "MuseumName": "CHESTERFIELD HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 85",
      "ZipCode": 1012,
      "StreetAddress(PhysicalLocation)": "66 EAST ST",
      "City(PhysicalLocation)": "CHESTERFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4132964465,
      "Latitude": 42.37424,
      "Longitude": -72.82383
    },
    {
      "ID": 204,
      "MuseumName": "CHEVALIER AUDITORIUM AND GENE MACK GYMNASIUM",
      "StreetAddress(AdministrativeLocation)": "102 BROOKS STREET",
      "ZipCode": 2155,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.4187,
      "Longitude": -71.10856
    },
    {
      "ID": 205,
      "MuseumName": "CHILD'S PLAY MUSEUM",
      "StreetAddress(AdministrativeLocation)": "293 LIBBEY INDUSTRIAL PKWY",
      "ZipCode": 2189,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7813377920,
      "Latitude": 42.18928,
      "Longitude": -70.93553
    },
    {
      "ID": 206,
      "MuseumName": "CHILDREN S MUSEUM LOWELL",
      "StreetAddress(AdministrativeLocation)": "11 KEARNEY SQ",
      "ZipCode": 1852,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9784599899,
      "Latitude": 42.64526,
      "Longitude": -71.30718
    },
    {
      "ID": 207,
      "MuseumName": "CHILDREN'S GLOBAL DISCOVERY MUSEUM",
      "StreetAddress(AdministrativeLocation)": "100 SOHIER ST",
      "ZipCode": 2025,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7813833198,
      "Latitude": 42.23904,
      "Longitude": -70.81426
    },
    {
      "ID": 208,
      "MuseumName": "CHILDREN'S MUSEUM",
      "StreetAddress(AdministrativeLocation)": "276 GULF ROAD",
      "ZipCode": 2748,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5089933361,
      "Latitude": 41.5815,
      "Longitude": -70.96304
    },
    {
      "ID": 209,
      "MuseumName": "CHILDREN'S MUSEUM",
      "StreetAddress(AdministrativeLocation)": "25 S WATER ST",
      "ZipCode": 2740,
      "StreetAddress(PhysicalLocation)": "25 S WATER ST",
      "City(PhysicalLocation)": "NEW BEDFORD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 41.63409,
      "Longitude": -70.92349
    },
    {
      "ID": 210,
      "MuseumName": "CHILDREN'S MUSEUM IN EASTON",
      "StreetAddress(AdministrativeLocation)": "9 SULLIVAN AVE",
      "ZipCode": 2356,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082303789,
      "Latitude": 42.0673,
      "Longitude": -71.08991
    },
    {
      "ID": 211,
      "MuseumName": "CHILDREN'S MUSEUM OF GREATER FALL RIVER",
      "StreetAddress(AdministrativeLocation)": "441 NORTH MAIN STREET",
      "ZipCode": 2720,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086720033,
      "Latitude": 41.70264,
      "Longitude": -71.15532
    },
    {
      "ID": 212,
      "MuseumName": "CHILDREN'S MUSEUM OF HOLYOKE",
      "StreetAddress(AdministrativeLocation)": "444 DWIGHT STREET",
      "ZipCode": 1040,
      "StreetAddress(PhysicalLocation)": "444 DWIGHT STREET",
      "City(PhysicalLocation)": "HOLYOKE",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.20571,
      "Longitude": -72.60598
    },
    {
      "ID": 213,
      "MuseumName": "CHILDREN'S MUSEUM OF PLYMUTH",
      "StreetAddress(AdministrativeLocation)": "PO BOX 3030",
      "ZipCode": 2361,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5087471234,
      "Latitude": 41.92334,
      "Longitude": -70.65561
    },
    {
      "ID": 214,
      "MuseumName": "CHILDREN'S MUSEUM OF WILBRAHAM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 522",
      "ZipCode": 1095,
      "StreetAddress(PhysicalLocation)": "678 MAIN ST",
      "City(PhysicalLocation)": "WILBRAHAM",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135962472,
      "Latitude": 42.11013,
      "Longitude": -72.43558
    },
    {
      "ID": 215,
      "MuseumName": "CHILDREN'S MUSEUM OF WORCESTER",
      "StreetAddress(AdministrativeLocation)": "54 BEECHING ST",
      "ZipCode": 1602,
      "StreetAddress(PhysicalLocation)": "222 HARRINGTON WAY",
      "City(PhysicalLocation)": "WORCESTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089292700,
      "Latitude": 42.26176,
      "Longitude": -71.76666
    },
    {
      "ID": 216,
      "MuseumName": "CITIZENS FOR PRESERVATION OF TOWN HALL",
      "StreetAddress(AdministrativeLocation)": "24 GAGE ST",
      "ZipCode": 2492,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.27878,
      "Longitude": -71.23504
    },
    {
      "ID": 217,
      "MuseumName": "CITYSPACE",
      "StreetAddress(AdministrativeLocation)": "50 PAYSON AVE",
      "ZipCode": 1027,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4135273997,
      "Latitude": 42.26527,
      "Longitude": -72.66971
    },
    {
      "ID": 218,
      "MuseumName": "CLARA BARTON BIRTHPLACE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "66 CLARA BARTON ROAD",
      "ZipCode": 1537,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5089872056,
      "Latitude": 42.15336,
      "Longitude": -71.89316
    },
    {
      "ID": 219,
      "MuseumName": "CLARA E. SEXTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "36 CONCORD RD",
      "ZipCode": 1821,
      "StreetAddress(PhysicalLocation)": "36 CONCORD RD",
      "City(PhysicalLocation)": "BILLERICA",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9786677020,
      "Latitude": 42.55581,
      "Longitude": -71.26959
    },
    {
      "ID": 220,
      "MuseumName": "CLINTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "210 CHURCH ST",
      "ZipCode": 1510,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9783680084,
      "Latitude": 42.41743,
      "Longitude": -71.68434
    },
    {
      "ID": 221,
      "MuseumName": "COACHMANS RIVER CENTER",
      "StreetAddress(AdministrativeLocation)": "67 HIGH ROAD",
      "ZipCode": 1951,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.79038,
      "Longitude": -70.85431
    },
    {
      "ID": 222,
      "MuseumName": "COASTAL MOUNTAIN RAILROAD",
      "StreetAddress(AdministrativeLocation)": "7 SILVA ST",
      "ZipCode": 1757,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086348597,
      "Latitude": 42.13945,
      "Longitude": -71.49877
    },
    {
      "ID": 223,
      "MuseumName": "CODMAN HOUSE",
      "StreetAddress(AdministrativeLocation)": "36 CODMAN RD",
      "ZipCode": 1773,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7812598843,
      "Latitude": 42.41617,
      "Longitude": -71.33115
    },
    {
      "ID": 224,
      "MuseumName": "COFFIN HOUSE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "5 LITTLES LN",
      "ZipCode": 1951,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9784622634,
      "Latitude": 42.79316,
      "Longitude": -70.85712
    },
    {
      "ID": 225,
      "MuseumName": "COHASSET HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "106 SOUTH MAIN ST",
      "ZipCode": 2025,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7813831434,
      "Latitude": 42.24145,
      "Longitude": -70.80436
    },
    {
      "ID": 226,
      "MuseumName": "COL KNOXS ARTILLERY REGIMENT",
      "StreetAddress(AdministrativeLocation)": "3 EUGENIE TER",
      "ZipCode": 1824,
      "StreetAddress(PhysicalLocation)": "3 EUGENIE TER",
      "City(PhysicalLocation)": "PO BOX 566",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9782564451,
      "Latitude": 42.58661,
      "Longitude": -71.34778
    },
    {
      "ID": 227,
      "MuseumName": "COLERAINE LAND & HISTORIC PRESERVATION TRUST",
      "StreetAddress(AdministrativeLocation)": "162 GRENFIELD ROAD",
      "ZipCode": 1340,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.66076,
      "Longitude": -72.67976
    },
    {
      "ID": 228,
      "MuseumName": "COLLECTION OF SCIENTIFIC INSTRUMENTS",
      "StreetAddress(AdministrativeLocation)": "1 OXFORD STREET",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6174952779,
      "Latitude": 42.36977,
      "Longitude": -71.11216
    },
    {
      "ID": 229,
      "MuseumName": "COLONEL ASHLEY HOUSE",
      "StreetAddress(AdministrativeLocation)": "117 COOPER HILL RD",
      "ZipCode": 1257,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4132983239,
      "Latitude": 42.10191,
      "Longitude": -73.36493
    },
    {
      "ID": 230,
      "MuseumName": "COLONIAL NEW ENGLAND MARTIAL MUSICK",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1916",
      "ZipCode": 1880,
      "StreetAddress(PhysicalLocation)": "21 PLEASANT ST",
      "City(PhysicalLocation)": "WAKEFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.50521,
      "Longitude": -71.06741
    },
    {
      "ID": 231,
      "MuseumName": "COLRAIN HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 45",
      "ZipCode": 1340,
      "StreetAddress(PhysicalLocation)": "8 MAIN ROAD",
      "City(PhysicalLocation)": "COLAIN",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.67279,
      "Longitude": -72.69761
    },
    {
      "ID": 232,
      "MuseumName": "COMM OF MASS FORT DEVENS MUSEUM",
      "StreetAddress(AdministrativeLocation)": "94 JACKSON ST",
      "ZipCode": 1432,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9787721286,
      "Latitude": 42.5667,
      "Longitude": -71.58643
    },
    {
      "ID": 233,
      "MuseumName": "COMM-MASS FORT DEVENS MUSEUM",
      "StreetAddress(AdministrativeLocation)": "94 JACKSON RD",
      "ZipCode": 1434,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9787721286,
      "Latitude": 42.53434,
      "Longitude": -71.62786
    },
    {
      "ID": 234,
      "MuseumName": "COMMONWEALTH MUSEUM",
      "StreetAddress(AdministrativeLocation)": "220 MORRISSEY BLVD",
      "ZipCode": 2125,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6177279268,
      "Latitude": 42.31635,
      "Longitude": -71.06072
    },
    {
      "ID": 235,
      "MuseumName": "COMMONWEALTH ZOOLOGICAL CORPORATION",
      "StreetAddress(AdministrativeLocation)": "1 FRANKLIN PARK RD",
      "ZipCode": 2121,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6179892000,
      "Latitude": 42.3029,
      "Longitude": -71.08643
    },
    {
      "ID": 236,
      "MuseumName": "CONCORD ANTIQUARIAN SOCIETY",
      "StreetAddress(AdministrativeLocation)": "200 LEXINGTON RD",
      "ZipCode": 1742,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.45784,
      "Longitude": -71.34185
    },
    {
      "ID": 237,
      "MuseumName": "CONCORD ART ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "37 LEXINGTON RD",
      "ZipCode": 1742,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9783692578,
      "Latitude": 42.4596,
      "Longitude": -71.34696
    },
    {
      "ID": 238,
      "MuseumName": "CONWAY HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 174",
      "ZipCode": 1341,
      "StreetAddress(PhysicalLocation)": "160 MAIN ST",
      "City(PhysicalLocation)": "CONWAY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 6034475551,
      "Latitude": 42.51488,
      "Longitude": -72.69913
    },
    {
      "ID": 239,
      "MuseumName": "COOPER-FROST-AUSTIN HOUSE",
      "StreetAddress(AdministrativeLocation)": "21 LINNAEAN ST",
      "ZipCode": 2138,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6179946669,
      "Latitude": 42.38415,
      "Longitude": -71.12237
    },
    {
      "ID": 240,
      "MuseumName": "COTOCHESET HISTORIC PRESERVATION TRUST",
      "StreetAddress(AdministrativeLocation)": "107 SEA VIEW AVENUE",
      "ZipCode": 2655,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 41.61608,
      "Longitude": -70.37035
    },
    {
      "ID": 241,
      "MuseumName": "CRACO SOCIETY",
      "StreetAddress(AdministrativeLocation)": "14 EARL ROAD",
      "ZipCode": 2537,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7742696611,
      "Latitude": 41.73807,
      "Longitude": -70.45351
    },
    {
      "ID": 242,
      "MuseumName": "CRANE MUSEUM OF PAPERMAKING",
      "StreetAddress(AdministrativeLocation)": "HOUSATONIC ST",
      "ZipCode": 1226,
      "StreetAddress(PhysicalLocation)": "40 PIONEER ST",
      "City(PhysicalLocation)": "DALTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4136846380,
      "Latitude": 42.47061,
      "Longitude": -73.17878
    },
    {
      "ID": 243,
      "MuseumName": "CROSBY MANSION",
      "StreetAddress(AdministrativeLocation)": "PO BOX 1888",
      "ZipCode": 2631,
      "StreetAddress(PhysicalLocation)": "163 CROSBY LANE",
      "City(PhysicalLocation)": "BREWSTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 41.78224,
      "Longitude": -70.03484
    },
    {
      "ID": 244,
      "MuseumName": "CROSSTOWN FOUNDATION FOR THE ARTS",
      "StreetAddress(AdministrativeLocation)": "1 NORTH SQUARE",
      "ZipCode": 2113,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6177200100,
      "Latitude": 42.36405,
      "Longitude": -71.05321
    },
    {
      "ID": 245,
      "MuseumName": "CUSHING HOUSE MUSEUM",
      "StreetAddress(AdministrativeLocation)": "98 HIGH ST",
      "ZipCode": 1950,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9784622681,
      "Latitude": 42.80727,
      "Longitude": -70.87168
    },
    {
      "ID": 246,
      "MuseumName": "CYCLING THROUGH HISTORY",
      "StreetAddress(AdministrativeLocation)": "17 ROSEMARY STREET",
      "ZipCode": 2494,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.28909,
      "Longitude": -71.23229
    },
    {
      "ID": 247,
      "MuseumName": "CYPRUS AMERICAN ARCHAEOLOGICAL RESEARCH INSTITUTE",
      "StreetAddress(AdministrativeLocation)": "656 BEACON ST STE 5",
      "ZipCode": 2215,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6173536571,
      "Latitude": 42.34936,
      "Longitude": -71.09602
    },
    {
      "ID": 248,
      "MuseumName": "CYRUS E DALLIN ART MUSEUM",
      "StreetAddress(AdministrativeLocation)": "611 MASSACHUSETTS AVENUE",
      "ZipCode": 2474,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7816410747,
      "Latitude": 42.41513,
      "Longitude": -71.15217
    },
    {
      "ID": 249,
      "MuseumName": "DANFORTH MUSEUM",
      "StreetAddress(AdministrativeLocation)": "123 UNION AVE",
      "ZipCode": 1702,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086200050,
      "Latitude": 42.28099,
      "Longitude": -71.41827
    },
    {
      "ID": 250,
      "MuseumName": "DANFORTH MUSEUM OF ART",
      "StreetAddress(AdministrativeLocation)": "123 UNION AVENUE",
      "ZipCode": 1702,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086200050,
      "Latitude": 42.28099,
      "Longitude": -71.41827
    },
    {
      "ID": 251,
      "MuseumName": "DANVERS ARCHIVAL CENTER",
      "StreetAddress(AdministrativeLocation)": "15 SYLVAN ST",
      "ZipCode": 1923,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9787740554,
      "Latitude": 42.55777,
      "Longitude": -70.94293
    },
    {
      "ID": 252,
      "MuseumName": "DANVERS HISTORICAL SOCIETY GLEN MAGNA",
      "StreetAddress(AdministrativeLocation)": "PO BOX 381",
      "ZipCode": 1923,
      "StreetAddress(PhysicalLocation)": "11 PAGE STREET",
      "City(PhysicalLocation)": "DANVERS",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 9787771666,
      "Latitude": 42.56538,
      "Longitude": -70.93665
    },
    {
      "ID": 253,
      "MuseumName": "DARTMOUTH HERITAGE PRESERVATION TRUST",
      "StreetAddress(AdministrativeLocation)": "PO BOX 87026",
      "ZipCode": 2748,
      "StreetAddress(PhysicalLocation)": "388 COUNTY ST",
      "City(PhysicalLocation)": "NEW BEDFORD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089931216,
      "Latitude": 41.6298,
      "Longitude": -70.92858
    },
    {
      "ID": 254,
      "MuseumName": "DARTMOUTH HISTORICAL AND ARTS SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 76",
      "ZipCode": 2714,
      "StreetAddress(PhysicalLocation)": "1205 RUSSELLS MILLS RD",
      "City(PhysicalLocation)": "DARTMOUTH",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089902854,
      "Latitude": 41.57329,
      "Longitude": -71.00436
    },
    {
      "ID": 255,
      "MuseumName": "DARWIN PROJECT",
      "StreetAddress(AdministrativeLocation)": "13 ARLINGTON STREET",
      "ZipCode": 2140,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.38644,
      "Longitude": -71.12115
    },
    {
      "ID": 256,
      "MuseumName": "DAVIS ART MUSEUM AND CULTURAL CENTER",
      "StreetAddress(AdministrativeLocation)": "106 CENTRAL ST",
      "ZipCode": 2481,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.29586,
      "Longitude": -71.29916
    },
    {
      "ID": 257,
      "MuseumName": "DE CORDOVA AND DANA MUSEUM AND PARK",
      "StreetAddress(AdministrativeLocation)": "51 SANDY POND RD",
      "ZipCode": 1773,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7812598355,
      "Latitude": 42.42857,
      "Longitude": -71.31337
    },
    {
      "ID": 258,
      "MuseumName": "DEDHAM HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 215",
      "ZipCode": 2027,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7813261385,
      "Latitude": 42.24873,
      "Longitude": -71.17498
    },
    {
      "ID": 259,
      "MuseumName": "DEDHAM VILLAGE PRESERVATION ASSOCIATION",
      "StreetAddress(AdministrativeLocation)": "27 COURT ST",
      "ZipCode": 2026,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7813264245,
      "Latitude": 42.24787,
      "Longitude": -71.17767
    },
    {
      "ID": 260,
      "MuseumName": "DENNIS HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 607",
      "ZipCode": 2660,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5083853689,
      "Latitude": 41.70749,
      "Longitude": -70.15848
    },
    {
      "ID": 261,
      "MuseumName": "DESIGN MUSEUM BOSTON",
      "StreetAddress(AdministrativeLocation)": "PO BOX 990938",
      "ZipCode": 2199,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.34583,
      "Longitude": -71.03654
    },
    {
      "ID": 262,
      "MuseumName": "DEVENS HISTORICAL MUSEUM",
      "StreetAddress(AdministrativeLocation)": "94 JACKSON RD STE 305",
      "ZipCode": 1434,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 8002941830,
      "Latitude": 42.53434,
      "Longitude": -71.62786
    },
    {
      "ID": 263,
      "MuseumName": "DIGAMMA BUILDING",
      "StreetAddress(AdministrativeLocation)": "12 MARSHALL ST",
      "ZipCode": 2108,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.34472,
      "Longitude": -71.07199
    },
    {
      "ID": 264,
      "MuseumName": "DIGHTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "1217 WILLIAMS ST",
      "ZipCode": 2715,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5086696888,
      "Latitude": 41.81589,
      "Longitude": -71.14102
    },
    {
      "ID": 265,
      "MuseumName": "DIGITAL HERITAGE MAPPING",
      "StreetAddress(AdministrativeLocation)": "304 NEWBURY STREET",
      "ZipCode": 2115,
      "StreetAddress(PhysicalLocation)": "SUITE 311",
      "City(PhysicalLocation)": "BOSTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 8572888075,
      "Latitude": 42.34251,
      "Longitude": -71.09102
    },
    {
      "ID": 266,
      "MuseumName": "DINOSAUR TRACK QUARRY",
      "StreetAddress(AdministrativeLocation)": "116 AMHERST RD",
      "ZipCode": 1075,
      "StreetAddress(PhysicalLocation)": "?39 ALDRICH STREET",
      "City(PhysicalLocation)": "SOUTH HADLEY",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4134679566,
      "Latitude": 42.23464,
      "Longitude": -72.58281
    },
    {
      "ID": 267,
      "MuseumName": "DISCOVERY MUSEUMS",
      "StreetAddress(AdministrativeLocation)": "177 MAIN ST",
      "ZipCode": 1720,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 9782644200,
      "Latitude": 42.46386,
      "Longitude": -71.45639
    },
    {
      "ID": 268,
      "MuseumName": "DOLL E DAZE PROJECT AND MUSEUM",
      "StreetAddress(AdministrativeLocation)": "12 COUNTY ST",
      "ZipCode": 2048,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.0381,
      "Longitude": -71.22022
    },
    {
      "ID": 269,
      "MuseumName": "DOORS TO HISTORY",
      "StreetAddress(AdministrativeLocation)": "23 T ST",
      "ZipCode": 2045,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.30287,
      "Longitude": -70.88303
    },
    {
      "ID": 270,
      "MuseumName": "DORCHESTER HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "195 BOSTON ST",
      "ZipCode": 2125,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6172657802,
      "Latitude": 42.32331,
      "Longitude": -71.06088
    },
    {
      "ID": 271,
      "MuseumName": "DOUGLAS HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 176",
      "ZipCode": 1516,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5084763856,
      "Latitude": 42.05794,
      "Longitude": -71.73184
    },
    {
      "ID": 272,
      "MuseumName": "DOVER HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 534",
      "ZipCode": 2030,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5087850236,
      "Latitude": 42.23749,
      "Longitude": -71.28523
    },
    {
      "ID": 273,
      "MuseumName": "DR. SEUSS NATIONAL MEMORIAL SCULPTURE GARDEN",
      "StreetAddress(AdministrativeLocation)": "21 EDWARDS ST",
      "ZipCode": 1103,
      "StreetAddress(PhysicalLocation)": "21 EDWARDS ST",
      "City(PhysicalLocation)": "SPRINGFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.1043,
      "Longitude": -72.58708
    },
    {
      "ID": 274,
      "MuseumName": "DRACUT HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "1660 LAKEVIEW AVENUE",
      "ZipCode": 1826,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.6782,
      "Longitude": -71.33897
    },
    {
      "ID": 275,
      "MuseumName": "DUXBURY RURAL AND HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 2865",
      "ZipCode": 2331,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 7819346106,
      "Latitude": 42.02599,
      "Longitude": -70.68381
    },
    {
      "ID": 276,
      "MuseumName": "DWIGHT-DERBY HOUSE",
      "StreetAddress(AdministrativeLocation)": "PO BOX 527",
      "ZipCode": 2052,
      "StreetAddress(PhysicalLocation)": "7 FRAIRY STREET",
      "City(PhysicalLocation)": "MEDFIELD",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5083596865,
      "Latitude": 42.18715,
      "Longitude": -71.30824
    },
    {
      "ID": 277,
      "MuseumName": "E.N. JENCKES STORE AND MUSEUM",
      "StreetAddress(AdministrativeLocation)": "283 MAIN STREET",
      "ZipCode": 1516,
      "StreetAddress(PhysicalLocation)": "283 MAIN STREET",
      "City(PhysicalLocation)": "DOUGLAS",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5084763856,
      "Latitude": 42.07527,
      "Longitude": -71.71118
    },
    {
      "ID": 278,
      "MuseumName": "EAST BOSTON GATEWAY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 584",
      "ZipCode": 2128,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.37956,
      "Longitude": -71.02887
    },
    {
      "ID": 279,
      "MuseumName": "EAST BRIDGEWATER HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 126",
      "ZipCode": 2337,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5085591510,
      "Latitude": 42.01183,
      "Longitude": -70.96402
    },
    {
      "ID": 280,
      "MuseumName": "EAST HAMPTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 727",
      "ZipCode": 1027,
      "StreetAddress(PhysicalLocation)": "7 HOLYOKE ST",
      "City(PhysicalLocation)": "EAST HAMPTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": null,
      "Latitude": 42.26263,
      "Longitude": -72.66231
    },
    {
      "ID": 281,
      "MuseumName": "EAST LONGMEADOW HIGH SCHOOL ATHLETIC HALL OF FAME",
      "StreetAddress(AdministrativeLocation)": "17 WATERMAN AVE",
      "ZipCode": 1028,
      "StreetAddress(PhysicalLocation)": "180 MAPLE STREET",
      "City(PhysicalLocation)": "EAST LONGMEADOW",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135255460,
      "Latitude": 42.0582,
      "Longitude": -72.52329
    },
    {
      "ID": 282,
      "MuseumName": "EAST TAUNTON BEER CAN MUSEUM",
      "StreetAddress(AdministrativeLocation)": "",
      "ZipCode": 2718,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": null,
      "Longitude": null
    },
    {
      "ID": 283,
      "MuseumName": "EAST WING ART GALLERY",
      "StreetAddress(AdministrativeLocation)": "444 GREEN ST",
      "ZipCode": 1440,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.59314,
      "Longitude": -71.98704
    },
    {
      "ID": 284,
      "MuseumName": "EASTHAM 1651 ARBORETUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 788",
      "ZipCode": 2642,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 41.83939,
      "Longitude": -69.99096
    },
    {
      "ID": 285,
      "MuseumName": "EASTHAM HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 8",
      "ZipCode": 2642,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 4134589594,
      "Latitude": 41.83939,
      "Longitude": -69.99096
    },
    {
      "ID": 286,
      "MuseumName": "EASTHAMPTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 992",
      "ZipCode": 1027,
      "StreetAddress(PhysicalLocation)": "7 HOLYOKE ST",
      "City(PhysicalLocation)": "EASTHAMPTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135273108,
      "Latitude": 42.26263,
      "Longitude": -72.66231
    },
    {
      "ID": 287,
      "MuseumName": "EASTON CHILDREN'S MUSEUM",
      "StreetAddress(AdministrativeLocation)": "PO BOX 417",
      "ZipCode": 2356,
      "StreetAddress(PhysicalLocation)": "9 SULLIVAN AVE",
      "City(PhysicalLocation)": "NORTH EASTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5082303789,
      "Latitude": 42.06707,
      "Longitude": -71.10254
    },
    {
      "ID": 288,
      "MuseumName": "EASTON HISTORICAL SOCIETY",
      "StreetAddress(AdministrativeLocation)": "PO BOX 3",
      "ZipCode": 2356,
      "StreetAddress(PhysicalLocation)": "80 MECHANIC STREET",
      "City(PhysicalLocation)": "NORTH EASTON",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5082387774,
      "Latitude": 42.06921,
      "Longitude": -71.10323
    },
    {
      "ID": 289,
      "MuseumName": "ECOTARIUM",
      "StreetAddress(AdministrativeLocation)": "222 HARRINGTON WAY",
      "ZipCode": 1604,
      "StreetAddress(PhysicalLocation)": "222 HARRINGTON WAY",
      "City(PhysicalLocation)": "WORCESTER",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 5089292700,
      "Latitude": 42.26176,
      "Longitude": -71.76666
    },
    {
      "ID": 290,
      "MuseumName": "EDDY HOMESTEAD",
      "StreetAddress(AdministrativeLocation)": "75 TABER STREET",
      "ZipCode": 2740,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 41.6275,
      "Longitude": -70.94051
    },
    {
      "ID": 291,
      "MuseumName": "EDITH WHARTON RESTORATION",
      "StreetAddress(AdministrativeLocation)": "PO BOX 974",
      "ZipCode": 1240,
      "StreetAddress(PhysicalLocation)": "2 PLUNKETT ST",
      "City(PhysicalLocation)": "LENOX",
      "State(PhysicalLocation)": "MA",
      "PhoneNumber": 4135515111,
      "Latitude": 42.33398,
      "Longitude": -73.27898
    },
    {
      "ID": 292,
      "MuseumName": "EDWARD DEVOTION HOUSE",
      "StreetAddress(AdministrativeLocation)": "347 HARVARD ST",
      "ZipCode": 2446,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 6175665747,
      "Latitude": 42.3437,
      "Longitude": -71.12365
    },
    {
      "ID": 293,
      "MuseumName": "EDWARD GOREY HOUSE",
      "StreetAddress(AdministrativeLocation)": "8 STRAWBERRY LN",
      "ZipCode": 2675,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5083623909,
      "Latitude": 40.74449,
      "Longitude": -73.98294
    },
    {
      "ID": 294,
      "MuseumName": "EDWARD M KENNEDY INSTITUTE",
      "StreetAddress(AdministrativeLocation)": "400 ATLANTIC AVENUE",
      "ZipCode": 2110,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 42.31635,
      "Longitude": -71.06072
    },
    {
      "ID": 295,
      "MuseumName": "EGAN INSTITUTE OF MARITIME",
      "StreetAddress(AdministrativeLocation)": "4 WINTER ST",
      "ZipCode": 2554,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": 5082282505,
      "Latitude": 41.28267,
      "Longitude": -70.10215
    },
    {
      "ID": 296,
      "MuseumName": "The Museum of Modern Art",
      "StreetAddress(AdministrativeLocation)": "The Museum of Modern Art",
      "ZipCode": 10019,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 40.761509,
      "Longitude": -73.978271
    },
    {
      "ID": 297,
      "MuseumName": "Whitney Museum of American Art",
      "StreetAddress(AdministrativeLocation)": "Whitney Museum of American Art",
      "ZipCode": 10019,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 40.7396,
      "Longitude": -74.0089
    },
    {
      "ID": 298,
      "MuseumName": "The Metropolitan Museum of Art",
      "StreetAddress(AdministrativeLocation)": "The Metropolitan Museum of Art",
      "ZipCode": 10019,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 40.7794,
      "Longitude": -73.9632
    },
    {
      "ID": 299,
      "MuseumName": "Solomon R. Guggenheim Museum",
      "StreetAddress(AdministrativeLocation)": "Solomon R. Guggenheim Museum",
      "ZipCode": 10019,
      "StreetAddress(PhysicalLocation)": "",
      "City(PhysicalLocation)": "",
      "State(PhysicalLocation)": "",
      "PhoneNumber": null,
      "Latitude": 40.783,
      "Longitude": -73.959
    }
 ]